import { createAsyncThunk } from "@reduxjs/toolkit";
import { api, extractStandardResponseData } from "../../api";
import { endpoints } from "../../api/endpoints";
import { Customer } from "../../shared/interfaces/Customer";
import { axiosResHandle } from "../ordersSlice/ordersProductSlice";
import { CustomerDetailsType } from "../../shared/types/customersSliceTypes";

export const searchCustomerWithTag = createAsyncThunk(
  "customers/searchWithTag",
  async (tag: string) =>
    api.get(endpoints.customersSearchWithTag, { params: { tag } }).then(extractStandardResponseData)
);
export const searchCustomer = createAsyncThunk("customers/search", async (q: string) =>
  api.get(endpoints.customersSearch, { params: { q } }).then(extractStandardResponseData)
);

export const deleteDeletedCustomer = createAsyncThunk(
  "customers/deleteCustomer",
  async ({ email }: Customer) => api.delete(`/customers/${email}`).then(extractStandardResponseData)
);

const getDetailsService = async (params: { email: string }) => {
  return api.get<CustomerDetailsType>(`/customers/details/${params.email}`);
};

export const getDetails = createAsyncThunk(
  "customers/details",
  async (params: { email: string }, { rejectWithValue }) => {
    try {
      const res = await getDetailsService(params);
      return axiosResHandle(res);
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

const editCustomerService = async (params: { id: number; email: string; phone: string }) => {
  return api.patch<CustomerDetailsType>(`/customers/contact/update`, { ...params });
};

export const editCustomer = createAsyncThunk(
  "customers/update",
  async (params: { id: number; email: string; phone: string }, { rejectWithValue }) => {
    try {
      const res = await editCustomerService(params);
      return axiosResHandle(res);
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);
